import { render } from "./TemplateMfittIndex.vue?vue&type=template&id=04374af2&scoped=true"
import script from "./TemplateMfittIndex.vue?vue&type=script&lang=js"
export * from "./TemplateMfittIndex.vue?vue&type=script&lang=js"

import "./TemplateMfittIndex.vue?vue&type=style&index=0&id=04374af2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-04374af2"

export default script